<template>
  <div class="columns">
    <div class="column is-2">
      <div class="select">
        <select v-on:change="changeField">
          <option value="taken">Datum</option>
          <option value="tags">Tags</option>
          <option value="camera">Kamera</option>
          <option value="lens_model">Objektiv</option>
        </select>
      </div>
    </div>
    <div class="column is-10">
        <div class="field has-addons" v-if="!filter.isDate">
            <span class="control is-expanded">
                <input class="input" type="text" v-model="term" v-on:keyup.enter="advancedSearch" />
            </span>
            <span class="control">
                <button class="button" v-on:click="deleteMe">
                    <i class="im im-trash-can" style="font-size: 18px;"></i>
                </button>
            </span>
        </div>
        <div v-if="filter.isDate">
          <div class="date-range is-hidden-mobile" >
            <datepicker placeholder="start date" input-class="input date start" v-model="startDate" :monday-first="true"></datepicker>
            <i class="icon im im-angle-right" style="font-size: 18px;"></i>
            <datepicker placeholder="end date" input-class="input date end" v-model="endDate" :monday-first="true"></datepicker>
            <button class="button" v-on:click="deleteMe">
                <i class="im im-trash-can" style="font-size: 18px;"></i>
            </button>
          </div>
          <div class="is-hidden-tablet">
            <datepicker placeholder="start date" input-class="input date start" v-model="startDate" :monday-first="true"></datepicker>
            <datepicker placeholder="end date" input-class="input date end" v-model="endDate" :monday-first="true"></datepicker>
            <button class="button" v-on:click="deleteMe">
                <i class="im im-trash-can" style="font-size: 18px;"></i>
            </button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { mapActions } from 'vuex'
export default {
  props: ["filter"],
  components: {
    Datepicker
  },
  computed: {
    term: {
      get () {
        return this.filter.term
      },
      set (value) {
        this.$store.commit('search/termChanged', {groupId: this.filter.groupId, filterId: this.filter.id, term: value})
      }
    },
    startDate: {
      get () {
        return this.filter.start;
      },
      set(value) {
        this.$store.commit('search/startChanged', {groupId: this.filter.groupId, filterId: this.filter.id, start: value})
      }
    },
    endDate: {
      get () {
        return this.filter.end;
      },
      set(value) {
        this.$store.commit('search/endChanged', {groupId: this.filter.groupId, filterId: this.filter.id, end: value})
      }
    }
  },
  methods: {
      deleteMe() {
          this.$store.commit("search/deleteFilter", this.filter);
      },
      changeField(e) {
        let field = null;
        for(let opt of e.target.options) {
          if(opt.selected) {
            field = opt.value;
            break;
          }
        }
        this.$store.commit("search/fieldChanged", {
          groupId: this.filter.groupId, 
          filterId: this.filter.id, 
          field: field
        })
      },
      ...mapActions("search", ["advancedSearch"])
  }
};
</script>